<template>
    <form-row title="Home Office Coordinator">
        <div class="flex-1">
            <div class="flex flex-col sm:flex-row">
                <div class="sm:col-gap-1 flex-1 -mt-2 sm:-mt-4">
                    <input-text
                        label="Name"
                        name="contacts[home_office_coordinator][name]"
                        :value="contact.name"
                        placeholder="Name"
                    />
                </div>

                <div class="sm:col-gap-1 flex-1 mt-2 sm:-mt-4">
                    <input-text
                        label="E-Mail"
                        name="contacts[home_office_coordinator][email]"
                        :value="contact.email"
                        placeholder="E-Mail"
                    />
                </div>

                <div class="sm:col-gap-1 flex-1 mt-2 sm:-mt-4">
                    <input-text
                        label="Phone"
                        name="contacts[home_office_coordinator][phone]"
                        :value="contact.phone"
                        placeholder="Phone"
                    />
                </div>
            </div>

            <send-notifications
                :name="'contacts[home_office_coordinator][receives_notifications]'"
                :value="'receives_notifications' in contact ? contact.receives_notifications : true"
            />
        </div>
    </form-row>
</template>

<script>
import SendNotifications from './send-notifications.vue';

export default {
    components: {
        SendNotifications,
    },

    props: {
        contact: { default: () => ({}) },
    },
}
</script>
